class CardCtrl {
  [x: string]: any;

  static $inject = ['Card', 'CardService'];

  constructor(Card, CardService) {
    this.Card = Card;
    this.CardService = CardService;
  }

  $onDestroy() {
    this.CardService.cancelChanging();
  }

  save() {
    this.saving = true;
    this.CardService.save(this.cardStripeElement)
      .then(() => this.success());
  }

  success() {
    this.saving = false;
    this.cardChanged();
  }
}

export default {
  controller: CardCtrl,
  template: require('./card.html'),
  bindings: {
    cardChanged: "&",
    cardValid: "&",
    card: "=",
    cardStripeElement: "=",
    showSteps: "@",
    invalid: "<",
    isAccount: "@"
  }
};
